(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusDialogController', Recall_statusDialogController);

    Recall_statusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Recall_status'];

    function Recall_statusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Recall_status) {
        var vm = this;

        vm.recall_status = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.recall_status.id !== null) {
                Recall_status.update(vm.recall_status, onSaveSuccess, onSaveError);
            } else {
                Recall_status.save(vm.recall_status, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:recall_statusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
